import React from "react";
import FeedbackContainer from "../Shared/FeedbackContainer";

export default function TeamLeaderScorecardsContainer() {
    return (
        <FeedbackContainer view='Team Leader Scorecards' />
    );
}
